/**
 * useDebounce — hook minimaliste partagé entre ProfessionPicker et
 * NirRefusalReasonPicker. Évite d'importer une lib.
 */
import { useEffect, useState } from 'react'

export function useDebounce<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value)
    useEffect(() => {
        const handle = setTimeout(() => setDebounced(value), delayMs)
        return () => clearTimeout(handle)
    }, [value, delayMs])
    return debounced
}
